import { z } from "zod";

export const serviceOptions = [
  { value: "3d-printing", label: "3D Printing" },
  { value: "3d-design", label: "3D Design" },
  { value: "rapid-prototyping", label: "Rapid Prototyping" },
  { value: "finishing", label: "Finishing" },
] as const;

export const allowedServiceValues = serviceOptions.map((option) => option.value) as [
  (typeof serviceOptions)[number]["value"],
  ...(typeof serviceOptions)[number]["value"][],
];

export const MAX_FILE_BYTES = 20 * 1024 * 1024;

export const allowedFileExtensions = [
  ".stl",
  ".obj",
  ".step",
  ".stp",
  ".zip",
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
] as const;

export const orderSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Nama minimal 2 karakter.")
    .max(80, "Nama terlalu panjang."),
  whatsapp: z
    .string()
    .trim()
    .regex(/^[+\d][\d\s()-]{7,20}$/, "Masukkan nomor WhatsApp yang valid."),
  email: z.string().trim().email("Masukkan alamat email yang valid.").max(160),
  service: z.enum(allowedServiceValues, {
    error: "Pilih salah satu layanan.",
  }),
  description: z
    .string()
    .trim()
    .min(20, "Ceritakan proyek minimal 20 karakter.")
    .max(2000, "Deskripsi maksimal 2.000 karakter."),
  website: z.string().max(0).optional(),
  startedAt: z.string().regex(/^\d+$/).optional(),
});

export type OrderInput = z.infer<typeof orderSchema>;

export function hasAllowedFileExtension(fileName: string) {
  const lowerName = fileName.toLowerCase();
  return allowedFileExtensions.some((extension) => lowerName.endsWith(extension));
}
